import React from 'react';
import {Box, Typography, Stack} from '@mui/material';
import {Button} from '@lightricks/react-design-system';
import Select from '@/components/select';
import styles from './DeveloperOverrideModal.module.scss';
import EmptyState from './EmptyState';

interface AddOverrideSectionProps {
  testID?: string;
  experimentOptions: Array<{id: string; label: string}>;
  selectedExperiment: string;
  selectedVariant: string;
  selectedExperimentVariants: Array<{id: string; label: string}>;
  onExperimentChange: (experimentId: string) => void;
  onVariantChange: (variantId: string) => void;
  onAddOverride: () => void;
  debugLogger: (message: string, ...args: any[]) => void;
}

function AddOverrideSection({
  testID = 'add-override-section',
  experimentOptions,
  selectedExperiment,
  selectedVariant,
  selectedExperimentVariants,
  onExperimentChange,
  onVariantChange,
  onAddOverride,
  debugLogger,
}: AddOverrideSectionProps) {
  return (
    <Box className={styles.addOverrideSection} data-testid={testID}>
      <Typography variant="h6" className={styles.sectionTitle}>
        Add Override
      </Typography>

      <Stack className={styles.formStack}>
        {experimentOptions.length > 0 ? (
          <>
            <Select
              label="Select experiment group"
              options={experimentOptions}
              variant="onboarding"
              selectedValueIds={selectedExperiment ? [selectedExperiment] : []}
              immediateOnChange
              onChange={(value) => {
                const experimentId = Array.isArray(value) ? value[0] : value;
                debugLogger('🔍 Experiment selected:', experimentId);
                onExperimentChange(experimentId);
              }}
            />

            <Box className={styles.variantSelectContainer}>
              {selectedExperiment && (
                <Select
                  label="Variant"
                  options={selectedExperimentVariants}
                  variant="onboarding"
                  selectedValueIds={selectedVariant ? [selectedVariant] : []}
                  immediateOnChange
                  onChange={(value) => {
                    const variantId = Array.isArray(value) ? value[0] : value;
                    debugLogger('🔍 Variant selected:', variantId);
                    onVariantChange(variantId);
                  }}
                />
              )}
            </Box>

            <Button
              size="medium"
              appearance="neutral"
              mode="filled"
              onClick={onAddOverride}
              disabled={!selectedExperiment || !selectedVariant}
              className={styles.addButton}
            >
              Add
            </Button>
          </>
        ) : (
          <EmptyState
            icon="Actions-Alert-Line"
            title="All experiment groups have been overridden"
            subtitle="Remove existing overrides to add new ones"
          />
        )}
      </Stack>
    </Box>
  );
}

export default AddOverrideSection;
